<template lang="pug">
Common.generate-error(title="Error Test" replaceTitle :errors='errors')
  h1(slot='header') Error Test

  main(slot='main')
    p This is a test for when errors are thrown in a page.
</template>

<script>
import { Common } from "AccountPages/components";
import { GemmaError } from "@gemma/errors";
import { CalendarDate } from "@gemma/dates";

export default {
  name: "Signup",
  components: {
    Common,
  },
  data() {
    return {
      errors: [],
    };
  },
  created() {
    throw new GemmaError("This is a test for when errors are thrown in a page.", { data: { date: CalendarDate.Today } });
  },
};
</script>
